module.exports = __webpack_public_path__ + "site/img/index11en.cb112912.png";